import { render, staticRenderFns } from "./NovoSimilar.vue?vue&type=template&id=a4c58f14&scoped=true"
import script from "./NovoSimilar.vue?vue&type=script&lang=js"
export * from "./NovoSimilar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4c58f14",
  null
  
)

export default component.exports